export enum RoleType {
  Default = 'default',
  Custom = 'custom',
  InstacartInternal = 'instacartInternal',
}
